@if (showBackButton()) {
  <oph-back-button (buttonClick)="onBackButtonClick()"></oph-back-button>
}

<h1>{{ title() }}</h1>

@if (showOverlay()) {
  <div class="conflict-overlay" (click)="closeOverlay()">
    <div class="overlay-content" (click)="$event.stopPropagation()">
      <img src="assets/img/icons/warning-orange.svg" />
      <h2>Tasks Affected</h2>
      <p>{{ conflictResponse().message || 'This will remove the user from tasks in the project.' }}</p>
      <div class="button-container">
        <oph-button
          color="green"
          [style]="{width: '68px', height: '36px', borderRadius: '12px', fontSize: '14px', fontWeight: '500'}"
          (buttonClick)="onConfirmRemove()"
          >OK</oph-button
        >
        <button class="close-button" (click)="closeOverlay()">Abort</button>
      </div>
    </div>
  </div>
}

<div class="button-group-container">
  <oph-button-group
    class="boolean-button-group"
    [options]="options"
    [selectedOptionName]="selectedOption()"
    [style]="{height: '36px'}"
    [buttonStyle]="{padding: '0px 10px', fontSize: '15px'}"
    (optionClick)="onOptionChange($event)"
  ></oph-button-group>
</div>

@if (selectedOption() === 'people') {
  <div class="grid-container">
    @for (user of availableUsers(); track user._id; let i = $index) {
      <button class="user-team-button" [class.selected]="isUserSelected(user._id)" (click)="toggleUser(user._id)">
        <div class="left-container">
          <oph-avatar [user]="user" [size]="36" [type]="'user'"></oph-avatar>
          <span class="name">{{ user.firstName }} {{ user.lastName }}</span>
        </div>
        @if (loadingObject()[user._id]) {
          <div class="oph-orange-spinner">
            <mat-spinner diameter="22"></mat-spinner>
          </div>
        } @else {
          @if (!isUserSelected(user._id)) {
            <img src="assets/img/icons/plus-orange.svg" />
          }
          @if (isUserSelected(user._id)) {
            <img src="assets/img/icons/check-green.svg" />
          }
        }
      </button>
    }
  </div>
}

@if (selectedOption() === 'teams') {
  <div class="grid-container">
    @for (team of availableTeams(); track team.id; let i = $index) {
      <button class="user-team-button" [class.selected]="isTeamSelected(team.id)" (click)="toggleTeam(team.id)">
        <div class="left-container">
          <oph-avatar [name]="team.name" [size]="36" [type]="'other'"></oph-avatar>
          <span class="name">{{ team.name }}</span>
        </div>
        @if (loadingObject()[team.id]) {
          <div class="oph-orange-spinner">
            <mat-spinner diameter="22"></mat-spinner>
          </div>
        } @else {
          @if (!isTeamSelected(team.id)) {
            <img src="assets/img/icons/plus-orange.svg" />
          }
          @if (isTeamSelected(team.id)) {
            <img src="assets/img/icons/check-green.svg" />
          }
        }
      </button>
    }
  </div>
}
